
import useUsuarioStore from '@/store/usuario';
import useChatStore from '@/store/chat';
import useMensajeStore from '@/store/mensaje';
import { useForm  } from 'vee-validate';
import  {required,min} from '@validations';

export default function useChat(){

  const chat_store = useChatStore();
  const router = useRouter();
  const usuario_store = useUsuarioStore();
  const {usuario_id,user:contacto} = storeToRefs(usuario_store);
  const show = ref(false);

  const mensaje_store = useMensajeStore();
  const {mensaje:formulario} = storeToRefs(mensaje_store);

  const {defineField,errors,handleSubmit,setErrors,resetForm} = useForm({
    initialValues:formulario,
    validationSchema:{
      mensaje:[required,(val,ctx) => min(val,40,ctx,'El mensaje debe tener al menos 40 caracteres')],
      
    }
  });

  const [mensaje,mensaje_attrs] = defineField('mensaje');
  const [archivos,archivos_attrs] = defineField('archivos');

  const aperturarChat = (user_id) => {

    if(!usuario_id.value) {
      preguntar({
        title:`Para enviar un mensaje debes iniciar sesión`,
        text: '¿Deseas iniciar sesión ahora?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sí, iniciar sesión',
        cancelButtonText: 'No, cancelar',
      }, () => {
        localStorage.setItem('redirect_after_login', router.currentRoute.value.fullPath);
        router.push({name:'login'})
      })

    }else{
      // verificar si el chat ya está iniciado y abierto. 

      chat_store.verificarChatConUsuario(contacto.value.id,usuario_id.value)
      .then(({result,slug}) => {
        if(result){
          // el chat ya está iniciado mandar al inbox. 
          router.push({name:'inbox',query:{contacto:slug}});
          toast.info('El chat con este usuario ya está iniciado. Puedes continuar en tu bandeja de entrada.');
        }else{
          // iniciar el chat en la modal dispuesta para ello. 
          show.value = true;

        }
      })
    }

  };


  const cerrarChat = () => {
    show.value = false;
  };

  const iniciarChatConUsuario = async () => {
    try {
        const {result,mensaje} = await chat_store.iniciarChatConUsuario(contacto.value.id,usuario_id.value);
        if(result){
          toast.info('Chat cargado correctamente.');
        }else{
          swal({
            title:'Error',
            text: mensaje,
            icon: 'error'
          })
        }

    } catch (error) {
        throw error;
    }
  };

  const cerrarChatConUsuario = async () => {
    try {
        await chat_store.cerrarChat(chat_store.chat.id);
    } catch (error) {
        throw error;
    }
  };


  watch(show, (new_val) => {
    
    if(new_val){
      let elemt_text_area = document.querySelector('.text-area-chat');
      if(elemt_text_area){
        elemt_text_area.focus();
      }
      // iniciarChatConUsuario();
    }else{
     

    }

  });

  const enviarMensaje = handleSubmit((values) => {
    preguntar({
      html: `${contacto.value.full_name} recibirá una notificación vía correo electrónico con tu mensaje, por lo general suele tardar unos mínutos en responder ¿Quieres continuar?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, enviar mensaje',
      cancelButtonText: 'No, cancelar',
    },() => {
      chat_store.iniciarChatConUsuario({
          ...values,
          contacto_id: contacto.value.id,
          usuario_id: usuario_id.value,
        })
        .then(({ result }) => {
          if (result) {
            resetForm();
            preguntar(
              {
                title: `Tú mensaje ha sido enviado correctamente.`,
                text: "¿Deseas continuar en el chat?",
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "No, cerrar chat",
              },
              () => {
                router.push({name:'inbox',query:{contacto:contacto.value.slug}})
                cerrarChat();
              },
              () => {
                cerrarChat();
              }
            );
          }else{
            toast.error('Ha ocurrido un error al enviar el mensaje, por favor intenta nuevamente.');
          }
        });
    },() => {
       resetForm();
    });
  });


  return {
    show,
    contacto,
    mensaje,
    archivos,
    archivos_attrs,
    mensaje_attrs,
    errors,
    archivos,
    aperturarChat,
    cerrarChat,
    enviarMensaje
  };

}